const config = { 
  gapi: {
    'apiKey': 'AIzaSyC7yUG8FVHGHu_2k_2awdkeTtkKoegR9Lc',
    'clientId': '19036940633-al8fsmcm3mkh0j1amb6r6pkpvnvrllgv.apps.googleusercontent.com',
    'scope': 'https://www.googleapis.com/auth/userinfo.email',
    'discoveryDocs': [
      'https://api-dot-ao-billing-platform-staging.appspot.com/_ah/api/discovery/v1/apis/billing/v1/rest'
    ]
  },
  debug: false
}

export default config;


// WEBPACK FOOTER //
// ./src/config.staging.js